export default class {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            $(".accordionItem").click(function () {
                const elem = this.closest("li");
                const outer = elem.querySelector(".outer");
                const elems = document.querySelectorAll(".accordionItem");

                if (
                    elem.classList.contains("open") &&
                    outer.classList.contains("open")
                ) {
                    elem.classList.remove("open");
                    outer.classList.remove("open");
                } else {
                    [].forEach.call(elems, function (el) {
                        el.classList.remove("open");
                        el.querySelector(".outer").classList.remove("open");
                    });
                    elem.classList.add("open");
                    outer.classList.add("open");
                }
            });
        });
    }
}
